var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartiemoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6548 20.6902C19.8986 20.6902 21.0126 12.6811 20.9999 10.6788V10.0114C21.0126 8.00912 19.8986 0 10.6548 0C1.41092 0 0.296982 8.00912 0.309662 10.0114V10.6788C0.296982 12.6811 1.41092 20.6902 10.6548 20.6902Z",
    fill: "url(#paint0_linear_967_3208)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04305 12.0244C4.99116 12.0129 4.93725 12.0142 4.88594 12.028C4.83463 12.0419 4.78744 12.068 4.74841 12.104C4.70938 12.1401 4.67967 12.1851 4.66182 12.2352C4.64398 12.2853 4.63853 12.3389 4.64593 12.3915C4.67007 12.6688 4.71808 12.9435 4.78943 13.2125C6.57922 14.2118 8.60185 14.7192 10.6514 14.6828C12.7011 14.7189 14.7238 14.2112 16.5134 13.2115C16.5848 12.9425 16.6328 12.6678 16.6569 12.3905C16.6644 12.3379 16.6589 12.2842 16.6411 12.2342C16.6232 12.1841 16.5935 12.1391 16.5545 12.103C16.5154 12.067 16.4682 12.0409 16.4169 12.027C16.3656 12.0132 16.3117 12.0119 16.2598 12.0234C14.4339 12.5356 12.5478 12.8014 10.6514 12.814C8.75516 12.8018 6.86901 12.5362 5.04305 12.0244Z",
    fill: "url(#paint1_linear_967_3208)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64647 12.0141H4.64914C4.64811 11.9649 4.65831 11.9161 4.67896 11.8715C4.69962 11.8268 4.73019 11.7874 4.76835 11.7563C4.80651 11.7253 4.85125 11.7033 4.89918 11.6921C4.9471 11.6809 4.99695 11.6808 5.04493 11.6918C6.87089 12.2035 8.75703 12.4691 10.6533 12.4813C12.5496 12.4688 14.4358 12.2029 16.2617 11.6908C16.3098 11.6798 16.3597 11.6799 16.4077 11.6911C16.4557 11.7024 16.5005 11.7245 16.5387 11.7556C16.5769 11.7868 16.6074 11.8263 16.628 11.8711C16.6486 11.9159 16.6587 11.9648 16.6575 12.0141H16.6602V12.3478H16.6575C16.6585 12.3626 16.6585 12.3775 16.6575 12.3922C16.6334 12.6695 16.5853 12.9442 16.514 13.2132C16.4706 13.3899 16.4159 13.5636 16.3505 13.7334C16.0004 14.6214 15.4129 15.3959 14.6522 15.9723C13.5149 16.8764 12.1049 17.3686 10.652 17.3686C9.1991 17.3686 7.78906 16.8764 6.65176 15.9723C5.89103 15.3959 5.30351 14.6214 4.95349 13.7334C4.88802 13.5636 4.8334 13.3899 4.78997 13.2132C4.71862 12.9442 4.67061 12.6695 4.64647 12.3922C4.64547 12.3775 4.64547 12.3626 4.64647 12.3478V12.0141Z",
    fill: "#ED8D06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.64914 12.3471C4.64811 12.2979 4.65831 12.2491 4.67896 12.2045C4.69962 12.1598 4.73019 12.1204 4.76835 12.0893C4.80651 12.0583 4.85125 12.0363 4.89918 12.0251C4.9471 12.0139 4.99695 12.0138 5.04493 12.0248C6.87089 12.5366 8.75703 12.8021 10.6533 12.8143C12.5496 12.8018 14.4358 12.5359 16.2617 12.0238C16.3098 12.0128 16.3597 12.0129 16.4077 12.0242C16.4557 12.0354 16.5005 12.0575 16.5387 12.0887C16.5769 12.1198 16.6074 12.1594 16.628 12.2041C16.6486 12.2489 16.6587 12.2979 16.6575 12.3471H16.6602V12.6809H16.6575C16.6585 12.6956 16.6585 12.7105 16.6575 12.7252C16.6334 13.0025 16.5853 13.2772 16.514 13.5462C16.4706 13.7229 16.4159 13.8967 16.3505 14.0664C16.0004 14.9544 15.4129 15.7289 14.6522 16.3053C13.5149 17.2094 12.1049 17.7016 10.652 17.7016C9.1991 17.7016 7.78906 17.2094 6.65176 16.3053C5.89103 15.7289 5.30351 14.9544 4.95349 14.0664C4.88802 13.8967 4.8334 13.7229 4.78997 13.5462C4.71862 13.2772 4.67061 13.0025 4.64647 12.7252C4.64547 12.7105 4.64547 12.6956 4.64647 12.6809V12.3471H4.64914Z",
    fill: "#F9BF06"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34368 16.9393C9.83332 17.4911 11.4713 17.4911 12.9609 16.9393C12.8511 16.649 12.3542 15.6846 10.6523 15.6846C8.95037 15.6846 8.45347 16.649 8.34368 16.9393Z",
    fill: "#8F030E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95513 13.7328C5.30515 14.6208 5.89267 15.3953 6.65339 15.9717C7.16422 16.3793 7.73477 16.7057 8.34499 16.9395C8.45478 16.6488 8.95168 15.6844 10.6536 15.6844C12.3556 15.6844 12.8525 16.6485 12.9622 16.9388C13.5725 16.705 14.143 16.3786 14.6538 15.9711C15.4146 15.3947 16.0021 14.6201 16.3521 13.7322C16.4176 13.5624 16.4722 13.3886 16.5156 13.2119C14.7259 14.2116 12.7033 14.7193 10.6536 14.6833C8.60394 14.7193 6.5813 14.2116 4.7916 13.2119C4.83496 13.3889 4.88958 13.5629 4.95513 13.7328Z",
    fill: "url(#paint2_linear_967_3208)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04305 12.0244C4.99116 12.0129 4.93725 12.0142 4.88594 12.028C4.83463 12.0419 4.78744 12.068 4.74841 12.104C4.70938 12.1401 4.67967 12.1851 4.66182 12.2352C4.64398 12.2853 4.63853 12.3389 4.64593 12.3915C4.67007 12.6688 4.71808 12.9435 4.78943 13.2125C6.57922 14.2118 8.60185 14.7192 10.6514 14.6828C12.7011 14.7189 14.7238 14.2112 16.5134 13.2115C16.5848 12.9425 16.6328 12.6678 16.6569 12.3905C16.6644 12.3379 16.6589 12.2842 16.6411 12.2342C16.6232 12.1841 16.5935 12.1391 16.5545 12.103C16.5154 12.067 16.4682 12.0409 16.4169 12.027C16.3656 12.0132 16.3117 12.0119 16.2598 12.0234C14.4339 12.5356 12.5478 12.8014 10.6514 12.814C8.75516 12.8018 6.86901 12.5362 5.04305 12.0244Z",
    fill: "url(#paint3_linear_967_3208)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04305 12.0244C4.99116 12.0129 4.93725 12.0142 4.88594 12.028C4.83463 12.0419 4.78744 12.068 4.74841 12.104C4.70938 12.1401 4.67967 12.1851 4.66182 12.2352C4.64398 12.2853 4.63853 12.3389 4.64593 12.3915C4.67007 12.6688 4.71808 12.9435 4.78943 13.2125C6.57922 14.2118 8.60185 14.7192 10.6514 14.6828C12.7011 14.7189 14.7238 14.2112 16.5134 13.2115C16.5848 12.9425 16.6328 12.6678 16.6569 12.3905C16.6644 12.3379 16.6589 12.2842 16.6411 12.2342C16.6232 12.1841 16.5935 12.1391 16.5545 12.103C16.5154 12.067 16.4682 12.0409 16.4169 12.027C16.3656 12.0132 16.3117 12.0119 16.2598 12.0234C14.4339 12.5356 12.5478 12.8014 10.6514 12.814C8.75516 12.8018 6.86901 12.5362 5.04305 12.0244Z",
    fill: "url(#paint4_linear_967_3208)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82074 3.95364C3.4526 3.52716 4.31258 4.33775 4.31258 4.33775C4.31258 4.33775 4.75775 3.1861 6.38961 2.75962C6.64419 2.67326 6.9141 2.64152 7.18177 2.66645C7.44943 2.69139 7.70884 2.77244 7.94309 2.90433C8.17734 3.03622 8.38116 3.21599 8.54129 3.43191C8.70142 3.64784 8.81425 3.89509 8.87244 4.15754C9.00508 4.63314 9.02008 5.13385 8.91615 5.61654C8.41351 7.53814 7.39918 9.28748 5.98115 10.6783C4.09862 10.1587 2.40401 9.11149 1.09725 7.6602C0.760934 7.29513 0.517468 6.85444 0.38744 6.3754C0.212574 5.73934 0.188881 4.38013 1.82074 3.95364Z",
    fill: "#EC3A4A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82074 3.95362C3.4526 3.52713 4.31258 4.33772 4.31258 4.33772C4.31258 4.33772 4.75775 3.18608 6.38961 2.75959C6.64421 2.67324 6.91415 2.64151 7.18183 2.66646C7.44952 2.69142 7.70894 2.7725 7.94319 2.90442C8.17744 3.03635 8.38127 3.21615 8.54138 3.43212C8.70149 3.64809 8.81429 3.89537 8.87244 4.15785C9.00508 4.63333 9.02008 5.13394 8.91616 5.61651C8.41352 7.53812 7.39918 9.28746 5.98115 10.6783C4.09863 10.1587 2.40401 9.11147 1.09725 7.66018C0.760937 7.2951 0.51747 6.85442 0.387442 6.37538C0.212576 5.73932 0.188883 4.38011 1.82074 3.95362Z",
    fill: "url(#paint5_linear_967_3208)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66197 3.35594C4.96337 3.80045 4.48883 4.95977 4.48883 4.95977C4.48883 4.95977 3.60416 4.15586 1.90555 4.60036C0.825324 4.88302 0.437216 5.53643 0.342108 6.13845C0.232984 5.44833 0.375479 4.33339 1.82546 3.95429C3.45732 3.52781 4.3173 4.3384 4.3173 4.3384C4.3173 4.3384 4.76248 3.18675 6.39433 2.76027C7.82797 2.38551 8.52209 3.25683 8.78906 3.90457C8.39662 3.43971 7.72819 3.07696 6.66197 3.35594Z",
    fill: "url(#paint6_linear_967_3208)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2.56093 6.37671C2.57239 6.45833 2.56545 6.54148 2.54062 6.62007C2.51579 6.69866 2.47369 6.7707 2.41741 6.83091C2.36113 6.89112 2.2921 6.93799 2.21536 6.96807C2.13863 6.99815 2.05614 7.01068 1.97393 7.00476C1.85201 6.99155 1.73226 6.96296 1.61752 6.91966C1.43327 6.85499 1.27338 6.73517 1.15959 6.57648C1.04579 6.41779 0.983602 6.22791 0.981465 6.03265C1.00014 5.8297 1.08302 5.63799 1.21807 5.48536C1.45868 5.19803 2.30798 4.74885 2.59797 5.19269C2.73146 5.39793 2.55926 5.76434 2.54725 5.99094C2.54079 6.11968 2.54537 6.24874 2.56093 6.37671Z",
    fill: "url(#paint7_linear_967_3208)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61298 5.25287C5.63 5.49181 5.51286 5.69737 5.37938 5.67134C5.32855 5.66183 5.28005 5.64257 5.23655 5.61461C5.14947 5.54393 5.08077 5.45324 5.03632 5.35028C4.99187 5.24731 4.97297 5.13512 4.98126 5.02327C4.98638 4.89635 5.01858 4.77198 5.0757 4.65852C5.17214 4.46697 5.51186 4.16763 5.62766 4.4633C5.6502 4.64119 5.64332 4.82158 5.6073 4.99724C5.60491 5.08249 5.6068 5.16781 5.61298 5.25287Z",
    fill: "url(#paint8_linear_967_3208)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4874 3.95362C17.8555 3.52713 16.9955 4.33772 16.9955 4.33772C16.9955 4.33772 16.5504 3.18608 14.9185 2.75959C14.6639 2.67324 14.394 2.64151 14.1263 2.66646C13.8586 2.69142 13.5992 2.7725 13.3649 2.90442C13.1307 3.03635 12.9268 3.21615 12.7667 3.43212C12.6066 3.64809 12.4938 3.89537 12.4357 4.15785C12.303 4.63333 12.288 5.13394 12.3919 5.61651C12.8946 7.53812 13.9089 9.28746 15.327 10.6783C17.2095 10.1587 18.9041 9.11147 20.2109 7.66018C20.5472 7.2951 20.7906 6.85442 20.9207 6.37538C21.0955 5.73932 21.1192 4.38011 19.4874 3.95362Z",
    fill: "url(#paint9_linear_967_3208)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6514 3.35594C16.35 3.80044 16.8245 4.95976 16.8245 4.95976C16.8245 4.95976 17.7092 4.15585 19.4078 4.60036C20.488 4.88301 20.8762 5.53642 20.9713 6.13844C21.0804 5.44832 20.9379 4.33338 19.4879 3.95429C17.8561 3.5278 16.9961 4.33839 16.9961 4.33839C16.9961 4.33839 16.5509 3.18675 14.919 2.76026C13.4841 2.3855 12.7896 3.25683 12.5233 3.9059C12.9168 3.4397 13.5852 3.07695 14.6514 3.35594Z",
    fill: "url(#paint10_linear_967_3208)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3073 5.17208C14.2716 5.24634 14.2197 5.31167 14.1555 5.3633C14.0912 5.41492 14.0163 5.45153 13.9361 5.47044C13.8559 5.48934 13.7724 5.49007 13.6919 5.47258C13.6114 5.45508 13.5358 5.41979 13.4707 5.3693C13.3765 5.29058 13.2927 5.2002 13.2214 5.10033C13.1042 4.94436 13.0378 4.7561 13.0313 4.56111C13.0248 4.36612 13.0785 4.17386 13.185 4.01042C13.3132 3.85198 13.4885 3.73849 13.6856 3.68638C14.0453 3.5806 15.0011 3.67804 14.9961 4.20831C14.9941 4.45326 14.6467 4.6625 14.5112 4.84437C14.4341 4.94763 14.3659 5.05726 14.3073 5.17208Z",
    fill: "url(#paint11_linear_967_3208)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4725 5.93115C17.354 6.13938 17.1421 6.24517 17.045 6.14939C17.008 6.11325 16.9785 6.0703 16.9579 6.02292C16.9247 5.91567 16.918 5.802 16.9383 5.6916C16.9586 5.5812 17.0053 5.47734 17.0743 5.38886C17.1493 5.28615 17.2452 5.2005 17.3557 5.13758C17.5419 5.03179 17.9897 4.97072 17.923 5.28174C17.8916 5.42524 17.6984 5.59009 17.6106 5.71323C17.5609 5.78431 17.5148 5.85706 17.4725 5.93115Z",
    fill: "url(#paint12_linear_967_3208)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91838 5.6168C9.0223 5.13423 9.0073 4.63362 8.87466 4.15814C8.79331 3.87058 8.65735 3.60138 8.47421 3.36523C8.83027 3.65516 9.08694 4.04903 9.20838 4.49185C9.34102 4.96733 9.35602 5.46794 9.25209 5.95051C8.74938 7.87209 7.73506 9.6214 6.31708 11.0123C4.52569 10.52 2.90326 9.5466 1.62574 8.19774C2.84751 9.37669 4.34593 10.2297 5.98337 10.6786C7.40134 9.28769 8.41566 7.53837 8.91838 5.6168Z",
    fill: "#ED8D06"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3932 5.6168C12.8964 7.53856 13.9113 9.28789 15.3299 10.6786C16.9673 10.2297 18.4657 9.37669 19.6875 8.19774C18.41 9.5466 16.7876 10.52 14.9962 11.0123C13.5776 9.6216 12.5627 7.87227 12.0595 5.95051C11.9556 5.46794 11.9706 4.96733 12.1032 4.49185C12.2246 4.04903 12.4813 3.65516 12.8374 3.36523C12.6542 3.60138 12.5183 3.87058 12.4369 4.15814C12.3043 4.63362 12.2893 5.13423 12.3932 5.6168Z",
    fill: "#ED8D06"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_967_3208",
    x1: 10.6548,
    y1: 0.101449,
    x2: 10.6548,
    y2: 20.7917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_967_3208",
    x1: 16.6583,
    y1: 13.3483,
    x2: 4.6446,
    y2: 13.3483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#D0CCC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#F2EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#F9F5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#E8E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_967_3208",
    x1: 10.6536,
    y1: 17.4447,
    x2: 10.6536,
    y2: 12.0272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69101B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.427,
    stopColor: "#400A10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_967_3208",
    x1: 10.6514,
    y1: 12.4012,
    x2: 10.6514,
    y2: 14.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B4B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.143,
    stopColor: "#D0CCC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#F2EDEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FFFAF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "#F9F5F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#E8E5E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_967_3208",
    x1: 10.6514,
    y1: 12.4012,
    x2: 10.6514,
    y2: 14.6444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABABAB",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.541,
    stopColor: "#C1C1C1",
    stopOpacity: 0.216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_967_3208",
    x1: 3.7723,
    y1: 2.73957,
    x2: 6.41898,
    y2: 10.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FF2D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#D41E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#D61F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#DE2337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#EB293E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_967_3208",
    x1: 4.09338,
    y1: 2.63646,
    x2: 4.67538,
    y2: 5.57414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF495D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_967_3208",
    x1: 1.63721,
    y1: 5.24942,
    x2: 2.24057,
    y2: 6.96938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF565A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#FF3D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_967_3208",
    x1: 5.18682,
    y1: 4.49066,
    x2: 5.58294,
    y2: 5.62028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF565A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#FF3D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_967_3208",
    x1: 17.5358,
    y1: 2.73957,
    x2: 14.8891,
    y2: 10.5485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#FF2D44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.722,
    stopColor: "#D41E32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.853,
    stopColor: "#D61F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.918,
    stopColor: "#DE2337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.968,
    stopColor: "#EB293E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F82F44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_967_3208",
    x1: 17.22,
    y1: 2.63645,
    x2: 16.638,
    y2: 5.57413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF495D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_967_3208",
    x1: 14.1616,
    y1: 3.71092,
    x2: 13.7092,
    y2: 5.47651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF565A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#FF3D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D44"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_967_3208",
    x1: 17.5381,
    y1: 5.05215,
    x2: 17.241,
    y2: 6.21202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF565A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#FF3D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2D44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartiemoji);
export default __webpack_public_path__ + "static/media/heartiemoji.6439a9a653c8d9d89a8dfd82762581ad.svg";
export { ForwardRef as ReactComponent };